export default __webpack_public_path__ + "static/client4-b110198b346b0005d57ec851c92287cf.jpg";